




















































import { computed, defineComponent } from '@vue/composition-api';
import { StepContentTypeEnum } from '@front-app/api-generated/learning-management-api';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { SETTINGS_ICON } from '@front-app/vendor/icon-definitions';

const TYPE_LABELS: Record<StepContentTypeEnum, string> = {
	[StepContentTypeEnum.Survey]: 'Survey',
	[StepContentTypeEnum.Youtube]: 'Youtube',
	[StepContentTypeEnum.Vimeo]: 'Vimeo',
};

export default defineComponent({
	components: {
		SimpleCard,
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		stepId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const programsStore = getLearningProgramsStore();
		const step = computed(() => programsStore.getStep(props.stepId));
		const typeString = computed(() => TYPE_LABELS[step.value.content.type]);
		return {
			step,
			typeString,
			SETTINGS_ICON,
		};
	},
});
